import React from "react";
import cn from "classnames";
import { ChildType } from "@common/types/tree-types";
import styles from "../TreeComponents.module.scss";
import { returnIconForChild } from "../../use-cases/return-icon-for-child";
import { CreateAncestorsLineageForSidePanel } from "@src/cloud-connect/node-manager/entities/create-ancestors-lineage-for-side-panel";
import { formatPathFromSegments } from "@src/cloud-connect/utils/format-path-from-segments";

interface IconInfoWrapperPropTypes {
  child: ChildType;
  type: "initial" | "machine";
  handleClickOnNode: (type: "initial" | "machine") => void;
}

const cssClassName = "filtered-node";

export const FilteredIconInfoWrapperOurNode = ({
  child,
  type,
  handleClickOnNode,
}: IconInfoWrapperPropTypes) => {
  const buildAncestorBreadCrumbs = () => {
    if (type === "initial") {
      return formatPathFromSegments(
        new CreateAncestorsLineageForSidePanel().createInitialStructureAncestorsLineageForSidePanel(
          child.id,
        ),
        { trimStart: false, trimEnd: false },
      );
    } else {
      return formatPathFromSegments(
        new CreateAncestorsLineageForSidePanel().createMachineStructureAncestorsLineageForSidePanel(
          child.id,
        ),
        { trimStart: false, trimEnd: false },
      );
    }
  };

  return (
    <span
      onClick={() => handleClickOnNode(type)}
      onKeyDown={() => handleClickOnNode(type)}
      role="button"
      className={cn(styles[`${cssClassName}__icon-info-wrapper`], {
        [styles[`${cssClassName}__icon-info-wrapper--unassigned`]]:
          child.unassigned,
      })}
      tabIndex={0}
    >
      <span
        className={cn(
          styles[`${cssClassName}__icon-wrapper`],
          styles[`${cssClassName}__icon-wrapper--${returnIconForChild(child)}`],
          {
            [styles[`${cssClassName}__icon-wrapper--unassigned`]]:
              child.unassigned,
          },
        )}
      />
      <span className={styles[`${cssClassName}__info-wrapper`]}>
        <span
          className={cn(styles[`${cssClassName}__name`], {
            [styles[`${cssClassName}__name--unassigned`]]: child.unassigned,
          })}
        >
          {child.name}
        </span>
        <span className={styles[`${cssClassName}__info`]}>
          {buildAncestorBreadCrumbs()}
        </span>
      </span>
    </span>
  );
};
